import { HiTrophy } from "react-icons/hi2";
import {
  CRICKET_ROUTE,
  EXCHANGE_SPORTS_ROUTE,
  HOME_ROUTE,
  IN_PLAY_ROUTE,
  MOBILE_ACCOUNTS_ROUTE,
  MULTI_MARKETS_ROUTE,
} from "@hypexone/uicore";
import { IoMdAlarm } from "react-icons/io";
import { IoHome } from "react-icons/io5";
import { BsFillPinFill } from "react-icons/bs";
import { FaUser } from "react-icons/fa6";

export const mobileFooterTabs = [
  {
    title: "Sports",
    langkey:"sports",
    imageSrc: HiTrophy,
    navigationUrl: `/exchange_sports/sports/cricket`,
  },
  {
    title: "In-Play",
    langkey:"in_play",
    imageSrc: IoMdAlarm,
    navigationUrl: `${IN_PLAY_ROUTE}`,
  },
  {
    title: "Home",
    langkey:"home",
    imageSrc: IoHome,
    navigationUrl: `${HOME_ROUTE}`,
  },
  {
    title: "Multi Market",
    langkey:"multimarkets",
    imageSrc: BsFillPinFill,
    navigationUrl: `${MULTI_MARKETS_ROUTE}`,
  },
  {
    title: "Account",
    langkey:"account",
    imageSrc: FaUser,
    navigationUrl: `${MOBILE_ACCOUNTS_ROUTE}`,
  },
];
